import React from 'react'
import MaldivesCharterTakeoverBackground from './components/MaldivesCharterTakeoverBackground'
import MaldivesCharterPageBanner from './components/MaldivesCharterPageBanner'

const maldivesCharterTakeoverConfig: App.SiteTakeoverConfig = {
  id: 'maldives-charter',
  palette: 'inverse',
  verticals: new Set(['home']),
  backgroundElement: MaldivesCharterTakeoverBackground,
  siteWide: {
    banner: {
      description: <MaldivesCharterPageBanner />,
      align: 'start',
      tabletAlign: 'center',
      logo: undefined
    }
  },
}

export default maldivesCharterTakeoverConfig
